import { useMutation, useQueryClient } from '@tanstack/react-query';

import { postData } from 'src/app/queries';

import { marketingCampaignsQueryKey } from './get-campaigns';

type AbridgedCampaign = {
  CampaignStatusId: number;
  MarketingCampaignId: number;
};

type UpdateCampaignStatusPayload = {
  MarketingCampaign: AbridgedCampaign;
};

export function useUpdateMarketingCampaignStatusMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (params: AbridgedCampaign) => {
      await postData<UpdateCampaignStatusPayload>({
        endpoint: 'api/marketing-campaign/update-campaign-status',
        payload: { MarketingCampaign: params },
      });
    },
    onSuccess: () => queryClient.invalidateQueries(marketingCampaignsQueryKey),
  });
}
